"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _utils = require("../../../../../configuration/utils");

var _constans = require("./../../../../../configuration/constans");

var _convertEntities = _interopRequireDefault(require("../../../../../configuration/convertEntities"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AppsComponent = function AppsComponent(_ref) {
  var currentTab = _ref.currentTab,
      tabName = _ref.tabName;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      appsAccordion = _useState2[0],
      setAppsAccordion = _useState2[1];

  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var apps = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.apps;
  });

  var findAppsLink = function findAppsLink(app) {
    var title = app.title ? app.title.replace(' ', '') : null;
    var newUrl = app.information.AppId ? "".concat(window.location.pathname, "?productId=").concat(app.information.AppId).concat(_constans.initialState.accessoryParametr) : dictionary.accessoriesListPath;
    return app.title && dictionary[title] ? dictionary[title] + _constans.initialState.accessoryParametr : newUrl;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: currentTab === tabName ? "tab__content__section active apps" : "tab__content__section apps",
    "data-content": tabName
  }, apps.map(function (app, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: appsAccordion === index ? "tab__content__section__row active" : "tab__content__section__row",
      key: index + 5
    }, (app === null || app === void 0 ? void 0 : app.images) && (app === null || app === void 0 ? void 0 : app.images.length) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab__content__section__row__image"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: (0, _utils.resolveImage)(app.images[0], _constans.fastlyCompressionQuery.appsTab),
      alt: app.title
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab__content__section__row__description"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
      onClick: function onClick() {
        return setAppsAccordion(appsAccordion === index ? null : index);
      }
    }, (0, _convertEntities["default"])(app.information.AppMarketingTitlePEP) || (0, _convertEntities["default"])(app.title), /*#__PURE__*/_react["default"].createElement("span", {
      className: appsAccordion === index ? "active" : ""
    })), (app === null || app === void 0 ? void 0 : app.images) && (app === null || app === void 0 ? void 0 : app.images.length) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab__content__section__row__image-mobile"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: (0, _utils.resolveImage)(app.images[0], _constans.fastlyCompressionQuery.appsTab) || '',
      alt: app.title,
      width: "260",
      height: "260"
    })), app.information.AppMarketingSubTitlePEP && /*#__PURE__*/_react["default"].createElement("p", {
      className: "tab__content__section__description__sub"
    }, (0, _convertEntities["default"])(app.information.AppMarketingSubTitlePEP)), app.information.AppMarketingDescriptionConsumer && /*#__PURE__*/_react["default"].createElement("p", {
      className: "tab__content__section__description__desc"
    }, (0, _convertEntities["default"])(app.information.AppMarketingDescriptionConsumer)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "product-link"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: app ? findAppsLink(app) : '#',
      tabIndex: 5,
      onClick: function onClick(e) {
        return (0, _utils.sendDataLayerEvent)('Tab', "Apps > ".concat(dictionary.productDetailsPath + dictionary[app.title] ? dictionary[app.title.replace(' ', '')] : '#'));
      }
    }, dictionary.readMore), /*#__PURE__*/_react["default"].createElement("span", {
      className: "pep-arrow"
    }, "\uEB4B")))));
  }));
};

var _default = AppsComponent;
exports["default"] = _default;